export class GooglePayment {
  amount: number;
  email: string;
  paymentMethodData: GooglePaymentMethodData;
}

export class GooglePaymentMethodData {
  description: string;
  tokenizationData: {
    type: string;
    token: string;
  };
  type: string;
  info: GooglePaymentInfo;
}

export class GooglePaymentInfo {
  cardNetwork: string;
  cardDetails: string;
  locationId: number;
  secretApiKey: string;
  serviceUrl: string;
  developerId: string;
  versionNumber: string;
  mid: string;
  deviceId: string;
  transactionKey: string;
  cardDataSource: string;
  level: string;
  invoiceNumber: string;
  transactionSource: string;
  orderId: string;
  terminalId: string;
  sourceComponent: string;
  transactionId: string;
  isPartialPayment: boolean;
  customerId: number;
  currency: string;
  cvn: string;
  billingAddress: GooglePayCustomerAddress;
}

export class GooglePayCustomerAddress {
  streetAddress1: string;
  streetAddress2: string;
  streetAddress3: string;
  city: string;
  province: string;
  state: string;
  postalCode: string;
  country: string;
  countryCode: string;
  name: string;
}
